<template>
    <section
        class="mm-section mm-section__banner"
        id="cover-image">
        <div class="mm-section-content box--flex-vertical mm-section-content--wider">
            <div
                class="mm-section__banner-headline">
                <div class="mm-section__banner-title">
                    <i class="mm-section__banner-logo icon icon-circle-check"></i>
                    <span>
                        {{title}}
                    </span>
                </div>
                <div class="mm-section__banner-subtitle">
                    {{description}}
                </div>
            </div>

            <div class="mm-section__banner-button">
                <div class="mm-section__col">
                    <SearchBox
                        formClass="mm-section__banner--searching-wrapper"
                        inputClass="searchbox-input--mm searchbox-input--mm-banner"
                        iconClass="hidden"
                        outerWrapperClassname="mm-section__banner--searching"
                        resultsClass="searchbox__results searchbox__results--banner-rounded"
                        :placeholderText="$t('UI.banners.searchPlaceholder')"
                        :apiSearchOperation="searchFulltext"
                        :minSearchValLength="3"
                        :onSelectItem="onSelectItem"
                        :transform="res => res.map(item => {
                            item.text = item.displayName;
                            return item;
                        })">
                        <template v-slot:afterInputSlot>
                            <button
                                type="button"
                                @click="openMap"
                                class="button main--button mm-section__banner--searching-button">
                                {{$te('homePage.openMapTitle') ? $t('homePage.openMapTitle') : ''}}
                            </button>
                        </template>
                    </SearchBox>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
//import SearchBox from '@/components/searchFulltext';
import SearchBox from '@/components/searchApi';
import { searchFulltext, openSearchResult, openMap } from '@/services/MapsfyApi';


export default {
    components: {
        SearchBox
    },
    props: {
        imageName: {
            type: String,
            required: true
        },
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    methods: {
        searchFulltext(value) {
            return searchFulltext(value);
        },
        onSelectItem(item) {
            this.$router.push({name: 'mapApp'});
            openSearchResult(item);
        },
        openMap() {
            this.$router.push({name: 'mapApp'});
            openMap();
        }
    }
}
</script>

<style scoped>

#cover-image {
    background-repeat: no-repeat;
    background-position: center center;
}


@media (max-width: 1920px) {
    #cover-image {
        background-image: url(/css/images/homepage/hp/Cover_Image_high.jpg);
    }
}

@media (min-width: 1920px) {
    #cover-image {
        background-image: url(/css/images/homepage/hp/Cover_Image_full.jpg);
    }
}

</style>